import cn from "classnames";
import React from "react";

const Toggle = (props) => {
    const { label, value, checked, onChange, className, fieldBeforeLabel } = props;
    return (
        <div className={cn("d-flex align-items-center", {}, [className])} onClick={() => onChange(!value)}>
            {label && !fieldBeforeLabel && <span className="small cursor-pointer switch__label">{label}</span>}
            <label className="switch">
                <span
                    className={cn("switch__slider", {
                        "switch__slider--checked": [true, false].includes(checked) ? checked : value,
                    })}
                ></span>
            </label>
            {label && fieldBeforeLabel && <span className="small cursor-pointer switch__label pl-2">{label}</span>}
        </div>
    );
};

export default Toggle;
